import { useTranslation } from 'react-i18next'

import { Box, HStack, Heading, Icon, List, ListItem } from '@chakra-ui/react'

import FacebookIcon from '@wwt/shared/assets/icons/logos/facebook.svg'
import InstagramIcon from '@wwt/shared/assets/icons/logos/instagram.svg'
import YouTubeIcon from '@wwt/shared/assets/icons/logos/youtube.svg'
import LiveChatIcon from '@wwt/shared/assets/icons/outline/livechat.svg'
import { FeatureIsNotImplemented } from '@wwt/ui/components'

import { FooterKey } from '../../types/FooterKey'

interface SocialIconPairs {
	[key: string]: typeof Icon
}

const socialNameToIcon: SocialIconPairs = {
	facebook: FacebookIcon,
	instagram: InstagramIcon,
	youtube: YouTubeIcon,
	liveChat: LiveChatIcon
} as SocialIconPairs

export interface FooterColumnProps {
	title: FooterKey
	links: Array<{
		name: FooterKey

		url?: string

		// TODO: Change this in future
		href?: string

		/**
		 * @default false
		 */
		isImplemented?: boolean
	}>
}

export const FooterColumn = ({ links, title }: FooterColumnProps) => {
	const { t } = useTranslation('footer')

	return (
		<Box>
			<Heading
				color="white"
				as="h3"
				fontSize="lg"
				fontWeight="600"
				mb="1.5rem"
			>
				{t(title)}
			</Heading>

			<List spacing="1rem">
				{links.map(linkInfo => (
					<ListItem key={linkInfo.name}>
						<HStack
							w={title === 'contacts' ? '7.6875rem' : 'unset'}
							justifyContent="space-between"
						>
							{linkInfo.isImplemented === undefined ? (
								<FeatureIsNotImplemented>
									<Box
										data-wwt-id="footer__item--link"
										// to={url}
										// as={LinkRouter}
										color="white"
										textDecoration="none"
										textStyle="body-text-6"
										_hover={{
											textDecoration: 'none',
											cursor: 'not-allowed',
											color: 'white'
										}}
										_active={{
											textDecoration: 'none'
										}}
									>
										{t(linkInfo.name)}
									</Box>
								</FeatureIsNotImplemented>
							) : (
								<Box
									data-wwt-id="footer__item--link"
									href={linkInfo.href}
									as="a"
									color="white"
									textDecoration="none"
									textStyle="body-text-6"
								>
									{t(linkInfo.name)}
								</Box>
							)}
							{title === 'contacts' && (
								<Icon
									as={socialNameToIcon[linkInfo.name]}
									viewBox="0 0 24 24"
									boxSize="1.5rem"
									color="white"
								/>
							)}
						</HStack>
					</ListItem>
				))}
			</List>
		</Box>
	)
}
